import { render, staticRenderFns } from "./82.vue?vue&type=template&id=2e4660fe&scoped=true&"
import script from "./82.vue?vue&type=script&lang=js&"
export * from "./82.vue?vue&type=script&lang=js&"
import style0 from "./82.vue?vue&type=style&index=0&id=2e4660fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4660fe",
  null
  
)

export default component.exports